import { render } from "./DialogStampRallyVersionWarning.vue?vue&type=template&id=799ee69e&scoped=true"
import script from "./DialogStampRallyVersionWarning.vue?vue&type=script&lang=js"
export * from "./DialogStampRallyVersionWarning.vue?vue&type=script&lang=js"

import "./DialogStampRallyVersionWarning.vue?vue&type=style&index=0&id=799ee69e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-799ee69e"

export default script